import { TuiScrollbar } from '@taiga-ui/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'x-requests',
  imports: [RouterOutlet, TuiScrollbar],
  templateUrl: './requests.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestsComponent {}
